<panel width="450">

  <h1>{{ (questionnaireQuestion.questionId ? 'questionnaire.edit-question' : 'questionnaire.new-question') | translate }}</h1>

  @if (!question) {
    <section>
      <skeletons [customSkeletons]="[['2em', '100%', 'col-6'], ['2em', '100%', 'col-6'], ['5em', '100%', 'col-12'], ['2em', '100%', 'col-12']]" />
    </section>
  }

  @if (question) {
    <section>
      @if (questionnaireQuestion.questionId) {
        <div>
          <label>{{ 'questionnaire.question-category-type' | translate }}</label>
          <div>{{ CategoryType[question.category!] }}</div>
        </div>
      }
      @if (!questionnaireQuestion.questionId) {
        <div>
          <custom-select [label]="'questionnaire.question-category-type' | translate" [placeholder]="'questionnaire.question-category-placeholder' | translate"
            [selectList]="questionCategoryTypeList"
            [(value)]="question.category"
          [required]="true"></custom-select>
        </div>
      }
      <div>
        <custom-select [label]="'questionnaire.question-reply-type' | translate" [placeholder]="'questionnaire.question-reply-placeholder' | translate"
          [selectList]="replyTypeList"
          [(value)]="question.questionReplyInputType"
        [required]="true"></custom-select>
      </div>
      @if (question.category == CategoryType.Product) {
        <add-multiple
          [label]="'questionnaire.question-products' | translate"
          [placeholder]="'questionnaire.question-products-placeholder' | translate"
          [(selectedItems)]="addedProducts"
          [availableItems]="productItems"
        [required]="true"></add-multiple>
      }
      <custom-input [label]="'questionnaire.question-text' | translate" [inputType]="inputTypeEnum.Textarea"
        [(value)]="question.questionText"
        [placeholder]="'questinnaire.question-text-placeholder' | translate"
      [required]="true"></custom-input>
      @if (isMultipleAnswersPossible()) {
        <custom-input
          [label]="'questionnaire.question-required-answers' | translate"
          [placeholder]="'questionnaire.question-required-answers-placeholder' | translate"
          [inputType]="inputTypeEnum.Number"
          [(value)]="question.requiredNumberOfReplies"
          [customValidState]="question.requiredNumberOfReplies != null && question.requiredNumberOfReplies > 0"
          [customValidationMessage]="'validation.number.greater-than' | translate: { 'value': 0 }"
        [required]="true"></custom-input>
      }
      @if (question) {
        <tags [(selectedTags)]="question.questionTags" [tags]="questionTags" />
      }
    </section>
  }

  @if (question && question.questionReplyInputType == ReplyType.Select) {
    <list-view scrollable>
      <header [sortColumn]="false">{{ 'questionnaire.question-reply-options' | translate }}</header>
      <header [sortColumn]="false"></header>
      <row *listData="let option from question.questionReplyOptions; let i = index;" [clickable]="false">
        <column><custom-input [(value)]="option.replyText" [required]="true" /></column>
        <column align-right><icon type="trash" (click)="removeOptionValue(i)" /></column>
      </row>
      <row [clickable]="false">
        <column>
        <button small [ignoreValidation]="true" [loader]="false" (click)="addOptionValue()"><icon type="plus" />{{ 'questionnaire.add-reply-option' | translate }}</button>
      </column>
      <column />
    </row>
  </list-view>
}


<section>
  <button [active]="enableSave" (click)="saveQuestion()" [label]="(questionnaireQuestion.questionId ? 'questionnaire.save' : 'questionnaire.create-question') | translate"></button>
</section>
</panel>
